var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusSelected = function SvgBusSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bus-selected_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#bus-selected_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.255 8.003C16.794 7.847 10 13.818 10 21.576c0 7.936 7 12.606 7 12.606L24 40l7-5.818s7-4.849 7-12.606c0-7.758-6.432-13.42-13.745-13.573Z",
    fill: "#1C1E21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.053 16C21.26 16 19 16.316 19 18.526v6.316c0 .556.246 1.055.632 1.402v1.124c0 .348.284.632.631.632h.632a.633.633 0 0 0 .631-.632v-.631h5.053v.631c0 .348.284.632.631.632h.632a.633.633 0 0 0 .632-.632v-1.124c.385-.347.631-.846.631-1.402v-6.316c0-2.21-2.26-2.526-5.052-2.526Zm3.574 1.888h-7.15c.348-.334 1.245-.625 3.576-.625 2.33 0 3.227.29 3.574.625Zm.215 1.264v1.9h-7.579v-1.9h7.58Zm-.215 6.151-.183.17h-6.783l-.183-.17a.611.611 0 0 1-.215-.46v-2.527h7.58v2.526a.611.611 0 0 1-.216.461Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.842 24.842a.947.947 0 1 0 0-1.895.947.947 0 0 0 0 1.895ZM26.263 24.842a.947.947 0 1 0 0-1.894.947.947 0 0 0 0 1.894Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bus-selected_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bus-selected_svg__b",
    x: 4,
    y: 6,
    width: 40,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_377_459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_377_459",
    result: "shape"
  })))));
};
export default SvgBusSelected;